import { render } from "./PAReportPage.vue?vue&type=template&id=4cb60ec6&ts=true"
import script from "./PAReportPage.vue?vue&type=script&lang=ts"
export * from "./PAReportPage.vue?vue&type=script&lang=ts"

import "./PAReportPage.vue?vue&type=style&index=0&id=4cb60ec6&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__